module.exports = __webpack_public_path__ + "img/stena21.98e927d4.jpg";